import PropTypes from 'prop-types';
import React from 'react';
import { WeezHeader } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

export default function WebserviceHome({ organization, subscriptionId }) {
    const { t } = useTranslation();
    return (
        <div>
            <WeezHeader title={t('ticket.webservice.dashboard-title')} />
            <div>work in progress</div>
        </div>
    );
}

WebserviceHome.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    organization: PropTypes.object.isRequired
};
